import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import {
  Form, Grid
  // Flag
} from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { push } from 'react-router-redux';
// import { map } from 'lodash';
import { omit, isEmpty } from 'lodash';

import { FORM_NAME } from '../forms/formConstant';
import {
  signUp,
  accountSignUp,
  updateUserProfile
} from '../actions';
import {
// HHFileUploader 
// HHSingleSelect,
// HHInput
} from './fields';
import FileUploader from '../uploader/Modal';

import { Input } from '../../uiStandard/event/input';
import { Dropdown } from '../../uiStandard/event/dropdown';
import { FormSubmitButton } from '../../uiStandard/event/formInput';
import { FormPhoneInputField } from '../../uiStandard/event/formPhoneInput';
import { isMobileAgent } from '../common/util';
import Avatar from '../common/avatar';
import { phoneRegEx } from './regex';
// import COUNTRY_CODES from './CountryCodes';

window.recaptchaOptions = {
  useRecaptchaNet: true
};

const formikEnhancer = withFormik({
  enableReinitialize: true,
  validationSchema: ({ translate }) => {
    const validationShape = {
      avatarUrl: Yup.string(),
      name: Yup.string(),
      phone: Yup.string().matches(phoneRegEx, translate('form.error.mixed.notType')),
      location: Yup.string().min(1, translate('form.error.string.min')).max(200, translate('form.error.string.max')).matches(/^[a-zA-Z0-9\s\u4e00-\u9fff]+$/, translate('form.error.validate.alphabetIntAndChineseOnly')),
      bio: Yup.string().min(1, translate('form.error.string.min')).max(100, translate('form.error.string.max')),
      education: Yup.string(),
      profession: Yup.string()
    };
    return Yup.object().shape(validationShape);
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    setSubmitting(true);
    const { phoneErr } = values;
    const omitVal = omit(values, ['phoneErr']);
    if (phoneErr) {
      const newVal = {
        ...omitVal,
        phone: ''
      };
      props.updateUserProfile(newVal, () => {
        props.push('/');
      });
    } else {
      props.updateUserProfile(values, () => {
        props.push('/');
      });
    }
  },
  displayName: FORM_NAME.SIGNUP_FORM
});

const RegularInput = styled(Input)`
  width: 338px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

// class DialCodeOptionComponent extends Component {
//   render() {
//     return (
//       <div
//         className={this.props.className}
//         onMouseDown={event => {
//           event.preventDefault();
//           event.stopPropagation();
//           this.props.onSelect(this.props.option, event);
//         }}
//         onMouseEnter={event => {
//           this.props.onFocus(this.props.option, event);
//         }}
//         onMouseMove={event => {
//           if (this.props.isFocused) return;
//           this.props.onFocus(this.props.option, event);
//         }}
//         title={this.props.option.title}
//       >
//         <Flag name={this.props.option.countryCode} /> {this.props.children}
//       </div>
//     );
//   }
// }

// const DialCodeValueComponent = props => (
//   <div className='Select-value' title={props.value.title}>
//     <span className='Select-value-label'>
//       <Flag name={props.value.countryCode} /> {props.children}
//     </span>
//   </div>
// );

const ProfileSignupForm = props => {
  const {
    translate, handleSubmit, values, user, isSubmitting, updateUserProfile, errors
  } = props;
  const isMobile = isMobileAgent();

  const styles = {
    gridRowPadding: {
      paddingTop: '7px',
      paddingBottom: '7px'
    }
  };

  const renderUserAvatar = (values, user) => (
    <Avatar
      avatarUrl={values.avatarUrl}
      user={user.profile}
      className='profile_info_basic_img'
      fontSize='3rem'
    />
  );

  const handleAvatarUrlUpdate = (key) => {
    updateUserProfile({ avatarUrl: `${key}` });
  };


  // const countryDialCodeOptions = map(COUNTRY_CODES, pcc => ({
  //   value: pcc.dial_code,
  //   countryCode: pcc.code,
  //   label: `(+${pcc.dial_code}) ${pcc.name}`
  // }));

  const educationOptions = [
    { value: 'High School', content: translate('form.label.highSchool') },
    { value: 'Diploma', content: translate('form.label.diploma') },
    { value: 'College', content: translate('form.label.college') },
    { value: 'University', content: translate('form.label.university') },
    { value: 'Master', content: translate('form.label.master') },
    { value: 'PhD', content: translate('form.label.PhD') },
    { value: 'Others', content: translate('common.others') }
  ];

  const professionOptions = [
    { value: 'Designer', content: translate('form.label.designer') },
    { value: 'Software Engineer', content: translate('form.label.softwareEngineer') },
    { value: 'Data Analysis', content: translate('form.label.dataAnalysis') },
    { value: 'AI', content: translate('form.label.AI') },
    { value: 'Businsess', content: translate('form.label.businsess') },
    { value: 'Human Resource', content: translate('form.label.humanResource') },
    { value: 'Finance', content: translate('form.label.finance') },
    { value: 'Marketing', content: translate('form.label.marketing') },
    { value: 'Health', content: translate('form.label.health') },
    { value: 'Others', content: translate('common.others') }
  ];

  return (
    <Form onSubmit={handleSubmit}>
      <Container>
        <Grid>
          <Grid.Row>
            {!isMobile &&
              <Grid.Column width={6}>
                <Form.Field className='completeProfile_avatar'>
                  <Field
                    name='avatarUrl'
                    component={FileUploader}
                    accept='image/*'
                    cropRatios={['1:1']}
                    onChange={handleAvatarUrlUpdate}
                    fileType='user_avatar'
                    trigger={renderUserAvatar(values, user)}
                  />
                </Form.Field>
              </Grid.Column>
            }
            <Grid.Column width={!isMobile ? 10 : 16}>
              <Grid>
                {
                  isMobile &&
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <Form.Field className='completeProfile_avatar'>
                        <Field
                          name='avatarUrl'
                          component={FileUploader}
                          accept='image/*'
                          cropRatios={['1:1']}
                          onChange={handleAvatarUrlUpdate}
                          fileType='user_avatar'
                          trigger={renderUserAvatar(values, user)}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                }
                <Grid.Row style={styles.gridRowPadding}>
                  {/* <Grid.Column width={7}>
                    <Field
                      name='countryDialCode'
                      component={HHSingleSelect}
                      otherProps={{
                        simpleValue: true,
                        clearable: true,
                        searchable: true,
                        options: countryDialCodeOptions,
                        placeholder: translate('form.placeholder.dialCode'),
                        optionComponent: DialCodeOptionComponent,
                        valueComponent: DialCodeValueComponent
                      }}
                    />
                  </Grid.Column> */}
                  <Grid.Column width={16}>
                    <Field
                      name='phone'
                      // component={HHInput}
                      component={FormPhoneInputField}
                      otherProps={{
                        type: 'text',
                        id: 'phone',
                        // icon: 'phone',
                        // iconPosition: 'left',
                        minLength: 7,
                        maxLength: 15,
                        placeholder: translate('form.placeholder.phoneNumber'),
                        label: translate('form.label.phoneNumber')
                      }}
                    />
                    <Field
                      name='phoneErr' render={({ field }) => (
                        <input value={field.value} type='hidden' />
                      )}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='location'
                        component={RegularInput}
                        otherProps={{
                          id: 'location',
                          placeholder: translate('form.placeholder.location'),
                          type: 'text',
                          label: translate('form.label.location')
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={styles.gridRowPadding}>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='bio'
                        component={RegularInput}
                        otherProps={{
                          id: 'bio',
                          placeholder: translate('form.placeholder.bio'),
                          type: 'text',
                          label: translate('form.label.bio')
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='education'
                        component={Dropdown}
                        otherProps={{
                          id: 'education',
                          listItems: educationOptions,
                          label: translate('yourEducation'),
                          placeholder: translate('yourEducation')
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16} textAlign='left'>
                    <Form.Field>
                      <Field
                        name='profession'
                        component={Dropdown}
                        otherProps={{
                          id: 'profession',
                          listItems: professionOptions,
                          label: translate('yourProfession'),
                          placeholder: translate('yourProfession')
                        }}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered>
            <Grid.Column width={8} mobile={16}>
              <RegularButton
                isSubmitting={isSubmitting}
                label={translate('button.confirm')}
                disabled={!isEmpty(errors)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Form>
  );
};

const Container = styled.div`
  margin-right: 60px;
  margin-left: 60px;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const RegularButton = styled(FormSubmitButton)`
  min-height: 41.13px;
  width: 338px;
  @media (max-width: 768px) {
    width: auto;
  }
`;

export default compose(
  withLocalize,
  connect(
    ({ user }) => ({ user }),
    {
      signUp,
      push,
      accountSignUp,
      updateUserProfile
    }
  ),
  formikEnhancer
)(ProfileSignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/profileSignupForm.js